import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Information — cercle + i duotone */
export const InfoIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      <circle cx="12" cy="12" r="8.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      <circle cx="12" cy="8" r="0.9" fill="var(--equiply-icon-fg)" />
      <path d="M12 11v6" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  ),
);
InfoIcon.displayName = "InfoIcon";
